<template>
  <el-container v-loading="loading">
    <el-header>
      <div class="nav-header">
        <el-row>
          <el-col :span="18">
            <span class="title" v-text="title"></span>
          </el-col>
          <el-col :span="6">
            <div class="layout-right">
              <el-button @click="handleBack">退回评审机构</el-button>
              <el-button
                type="primary"
                icon="el-icon-video-play"
                @click="handleAudit"
              >
                确定并审核通过
              </el-button>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-header>

    <el-main>
      <Base ref="Main" @set-title="handleTitle"></Base>
      <Mavin ref="Mavin" class="mt10"></Mavin>
      <Feedback ref="Feedback"></Feedback>
    </el-main>
  </el-container>
</template>

<script>
import Base from './components/Base.vue';
import Mavin from './components/Mavin.vue';
import Feedback from './components/Feedback.vue';

import { flowAudit } from '@/api/shares/opers/flow.js';

export default {
  data() {
    return {
      loading: false,
      title: '...',
      subTitle: ''
    };
  },
  components: {
    Base,
    Mavin,
    Feedback
  },
  methods: {
    handleBack() {
      this.$refs.Feedback.show();
    },
    handleAudit() {
      this.$confirm('您是确定要审核吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true;
        flowAudit(this.$route.params.shareEid)
          .then(() => {
            this.msgSuccess();
            window.close();
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
    handleClose() {
      window.close();
    },
    handleTitle(title) {
      this.title = title;
    }
  }
};
</script>

<style lang="scss" scoped>
.nav-header {
  .layout-right {
    padding: 10px;
  }
}
</style>
